import { Injectable } from '@angular/core';
import { Cache, cacheable, BlobSerializer } from '../cache/index';
import { HttpHeaderContentType } from '../shared/Enums';
import { ApiService } from '../system-services/Api.service';

// There's only one error pdf
const errorPdfId = 'Ravioli ravioli, give me the formuoli';

@Injectable({
    providedIn: 'root'
})
export class CommonErrorApi {
    private errorPdfCache = new Cache<any, string>(
        'errorPdfCache',
        () => errorPdfId
    );

    constructor(private api: ApiService) {}

    @cacheable(
        function (this: CommonErrorApi) {
            return this.errorPdfCache;
        },
        () => errorPdfId,
        null,
        new BlobSerializer()
    )
    private getErrorPdfRaw() {
        return this.api.getResourceUrl(
            '/Assets/error.pdf',
            HttpHeaderContentType.PDF,
            false,
            null,
            location.protocol + '//' + location.host
        );
    }

    getErrorPdf() {
        return this.api.processResourceUrl(
            this.getErrorPdfRaw(),
            HttpHeaderContentType.PDF
        );
    }
}
